"use client";

import { useRouter } from "next/navigation";
import { useCallback } from "react";

import { getNextPageSlug } from "../navigation/getNextPageSlug";
import { getPreviousPageSlug } from "../navigation/getPreviousPageSlug";
import { SignupFlowSlug } from "../constants";

import { useFlowNavigationContext } from "./useFlowNavigationContext";

export interface FlowNavigation {
  goToNext: () => void;
  goBack: () => void;
  canContinue: boolean;
  canGoBack: boolean;
  nextPageSlug: SignupFlowSlug | null;
}

export function useFlowNavigation(currentSlug: string): FlowNavigation {
  const router = useRouter();
  const context = useFlowNavigationContext();

  const nextPageSlug = getNextPageSlug(currentSlug, context);
  const previousPageSlug = getPreviousPageSlug(currentSlug, context);

  const canContinue = nextPageSlug !== null;
  const canGoBack = previousPageSlug !== null;

  const goToNext = useCallback(() => {
    if (canContinue && nextPageSlug) {
      router.push(nextPageSlug);
    }
  }, [ canContinue, nextPageSlug, router ]);

  const goBack = useCallback(() => {
    if (canGoBack && previousPageSlug) {
      router.push(previousPageSlug);
    }
  }, [ canGoBack, previousPageSlug, router ]);

  return {
    goToNext,
    goBack,
    canContinue,
    canGoBack,
    nextPageSlug,
  };
}
